import type { SearchParamsWithSavedsSearchId } from './types';

export default (params: SearchParamsWithSavedsSearchId) => {
  delete params.savedsearchid;
  delete params.page;

  return params;
};
